// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checklist-option[data-v-12aa27c4]{line-height:1.2;padding:4px 0}.checklist-option__title[data-v-12aa27c4]{font-size:13px;font-weight:600}.checklist-option__uuid[data-v-12aa27c4]{color:#8a8a8a;font-size:12px;margin-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
